<template>
    <div>
        <div class="d-flex d-flex-space-between">
            <div class="label">
                <span>{{ $t("selected_package") }} : </span>
                <strong>{{ showInfo('name') }}</strong>
            </div>
            <div class="fw-bold">{{ showInfo('price') }}</div>
        </div>
        <p class="label-upgrade">{{ $t('choose_payment_method') }}</p>
        <div class="d-flex slect-method">
            <template v-for="(gate, index) in gates">
                <input :id="'method_' + index" name="radio-select" type="radio" v-model="method" :value="gate.method" />
                <label :for="'method_' + index" class="payment-method-item box-shadow-main">
                    <div class="img-gate-box">
                        <img :src="gate.icon">
                    </div>
                    <div class="payment-method-text" v-html="gate.name"></div>
                </label>
            </template>
        </div>
        <div class="d-flex justify-content-center">
            <div class="btn-payment box-shadow-main btn-payment-change btn-undo" @click="updateStep(2)">{{ $t('back') }}</div>
            <div class="btn-payment box-shadow-main btn-payment-change" :class="{ 'disabled': method === '' }" @click="method != '' ? updateStep(4) : ''" :aria-disabled="method === ''">{{ $t('pay_now') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpgradeFeaturePayment',
    props: {
        package_select: {
            type: String,
            required: true
        },
        showInfo: {
            type: Function,
            required: true
        },
        gates: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            method: ''
        }
    },
    methods: {
        updateStep(step) {
            this.$emit('updateStep', step, '', this.method);
        }
    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.slect-method [type="radio"]+label:before,
.slect-method [type="radio"]+label:after {
    display: none;
}

.slect-method [type=radio]:checked+label.payment-method-item {
    opacity: 1;
    border: 2px solid #40C0F6;
}

.slect-method label {
    display: block;
}

.payment-method-item {
    display: flex;
    min-height: 180px;
    padding: 12px;
}

.img-gate-box {
    padding: 20px 25px 10px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.img-gate-box img {
    width: 100%;
    height: 140px !important;
    object-fit: contain;
}

.payment-method-text {
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin-top: 6px;
    text-align: center;
    margin-top: 10px;
    display: block;
}

.d-flex-space-between {
    justify-content: space-between;
    margin-bottom: 15px;
}

.btn-payment-change {
    margin: 30px 5px;
}

.btn-undo {
    background: #fff;
    color: #212529;
    width: 120px;
}

.btn-payment.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}
</style>